import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchNamespaceOverview } from '@/slices/namespaceSlice';
import { content } from '@/components/Cluster/TopicTip';
import SummaryPanel from '@/components/Cluster/SummaryPanel';
import PermWrapper from '@/components/PermWrapper';

function Summary({ overview, fetchNamespaceOverview, loading }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  useEffect(() => {
    if (clusterName) {
      fetchNamespaceOverview(clusterName);
    }
  }, [clusterName, fetchNamespaceOverview]);

  const items = [
    {
      title: '命名空间',
      icon: 'other2',
      info: <CountUp end={overview.totalNamespaceCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Bundle',
      info: <CountUp end={overview.bundleCount} duration={0.4} />,
      tip: '分配的Bundle个数（可进行负载均衡最小粒度）。',
      icon: 'other3',
      unit: '个',
    },
    {
      title: 'Topic',
      icon: 'topic',
      info: (
        <>
          <CountUp end={overview.totalTopicPartitionCount} duration={0.4} />/
          <CountUp end={overview.totalTopicCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: content,
    },
    {
      title: '订阅',
      icon: 'subscription',
      info: (
        <>
          <CountUp end={overview.totalSubscriptionOnlineCount} duration={0.4} />/
          <CountUp end={overview.totalSubscriptionCount} duration={0.4} />
        </>
      ),
      unit: '个',
      tip: (
        <div>
          <strong>
            订阅({overview.totalSubscriptionOnlineCount || 0}/{overview.totalSubscriptionCount || 0}
            )
          </strong>
          <li>{overview.totalSubscriptionOnlineCount || 0}代表在线订阅数。</li>
          <li>{overview.totalSubscriptionCount || 0}代表总订阅数。</li>
        </div>
      ),
    },
  ];
  return (
    <PermWrapper resource='pulsar:namespace:list:summary'>
      <Loading loading={loading} size='small'>
        <SummaryPanel shadow items={items} />
      </Loading>
    </PermWrapper>
  );
}

export default connect(
  (state) => ({
    overview: state.namespace.overview,
    loading: state.namespace.loading,
  }),
  {
    fetchNamespaceOverview,
  },
)(Summary);
